import React from "react";

import InputImage from "../../components/InputImage";
import { InputSeoComponent } from "../../components/InputSeo";

// Controlado pela edição da marca: os campos entram no mesmo "Salvar
// alterações" da página, não há salvamento próprio aqui.
export const SeoTab = ({ seo, onChange, ogImageBase64, setOgImageBase64, ogImagePreview, setOgImagePreview, faviconUrl, siteUrl }) => {
    const set = key => value => onChange({ ...seo, [key]: value });

    const ogImage = ogImageBase64 || ogImagePreview;
    const host = (siteUrl || '').replace(/^https?:\/\//, '').replace(/\/$/, '') || 'suamarca.marcas.brinde.me';

    const seoGoogle = [
        {
            label: "Título da página",
            value: seo.title ?? '',
            onChange: set('title'),
            placeholder: "Ex: Brindes Personalizados | Minha Marca",
            maxLength: 60
        },
        {
            label: "Descrição da página",
            value: seo.description ?? '',
            onChange: set('description'),
            placeholder: "Brindes promocionais personalizados com entrega rápida...",
            maxLength: 160
        }
    ];

    const seoSocials = [
        {
            label: "Título redes sociais",
            value: seo.og_title ?? '',
            onChange: set('og_title'),
            placeholder: "Título Open Graph",
            maxLength: 60
        },
        {
            label: "Descrição redes sociais",
            value: seo.og_description ?? '',
            onChange: set('og_description'),
            placeholder: "Confira nossos brindes personalizados...",
            maxLength: 160
        }
    ];

    return (
        <div className="brand-overview brand-seo">
            <section className="brand-section">
                <div className="brand-tab-head">
                    <div>
                        <h2 className="section-title">SEO e compartilhamento</h2>
                        <p className="section-hint">
                            Como a home do site da marca aparece no Google e ao ser compartilhada em redes sociais e no WhatsApp.
                        </p>
                    </div>
                </div>

                <div className="brand-seo-columns">
                    <div className="brand-seo-column">
                        <h3>Buscadores</h3>
                        <InputSeoComponent fields={seoGoogle} />

                        <div className="seo-preview">
                            <h4>Prévia Google</h4>
                            <div className="google-preview">
                                <div className="google-titles">
                                    {faviconUrl &&
                                        <img className="google-favicon-preview" src={faviconUrl} alt="" />
                                    }
                                    <div className="google-urls">
                                        <div className="url-clean">{host}</div>
                                        <div className="url">https://{host}/</div>
                                    </div>
                                </div>
                                <div className="title">{seo.title || 'Título da página'}</div>
                                <div className="desc">{seo.description || 'Descrição da página'}</div>
                            </div>
                        </div>
                    </div>

                    <div className="brand-seo-column">
                        <h3>Redes sociais</h3>
                        <InputSeoComponent fields={seoSocials} />

                        <div className="brand-seo-og-image">
                            <InputImage
                                label={`Imagem de compartilhamento`}
                                src={ogImage}
                                changeBase64={setOgImageBase64}
                                onRemove={() => setOgImagePreview(null)}
                                hint={`1200px por 630px`}
                                formats={['jpeg', 'png']}
                            />
                        </div>

                        <div className="seo-preview">
                            <h4>Prévia redes sociais</h4>
                            <div className="social-preview">
                                <div className="img">
                                    {ogImage
                                        ? <img src={ogImage} alt="" />
                                        : <div className="placeholder">Sem imagem</div>
                                    }
                                </div>
                                <div className="body">
                                    <div className="host">{host}</div>
                                    <div className="title-socials">{seo.og_title || 'Título'}</div>
                                    <div className="description-socials">{seo.og_description || 'Descrição'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SeoTab;
